import React from 'react'
import CardItem from './CardItem'
import './Cards.css';
import Reymark from '../../src/components/images/img-1.jpg'
import Weifang from '../../src/components/images/img-2.jpg'
import Koen from '../../src/components/images/img-3.jpg'
import Danny from '../../src/components/images/img-4.jpg'
import Eddie from '../../src/components/images/img-5.jpg'

function Cards() {
    return (
        <div className='cards'>
            <h1>Our Team</h1>
            <div className="cards__container">
                <div className="cards__wrapper">
                    <ul className="cards__items">
                        <CardItem 
                        src={Reymark}
                        text="Reymark Schraagen"
                        label='Product Owner'
                        path='/team5'
                        />
                        <CardItem 
                        src={Weifang}
                        text="Weifang Lei"
                        label='Scrum Master'
                        path='/team5'
                        />
                        <CardItem 
                        src={Koen}
                        text="Koen Benne"
                        label='Full Stack Developer'
                        path='/team5'
                        />
                        <CardItem 
                        src={Danny}
                        text="Danny Hu"
                        label='Back-end Developer'
                        path='/team5'
                        />
                        <CardItem 
                        src={Eddie}
                        text="Eddie Lau"
                        label='Front-end Developer'
                        path='/team5'
                        />
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default Cards
